import { render } from "./PricingPlans.vue?vue&type=template&id=3511108e&ts=true"
import script from "./PricingPlans.vue?vue&type=script&lang=ts"
export * from "./PricingPlans.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__